// extracted by mini-css-extract-plugin
export default {"groupForm":"AddClient_groupForm__IFa8o","btns":"AddClient_btns__2GYE9"};